visibleDirective.$inject = [];

export function visibleDirective() {
    return {
        restrict: 'A',
        multiElement: true,
        link: function(scope, element, attr) {
            scope.$watch(attr.appVisible, function appVisibleWatchAction(value) {
                if (!value) {
                    element.css('visibility', 'hidden');
                } else {
                    element.css('visibility', null);
                }
            });
        },
    };
}
